import { createGlobalStyle } from "styled-components";
import styled from "styled-components";
// import React from "react";

const GlobalStyles = createGlobalStyle`
:root{
    --gray-0 :#F5F5F5;
    --color-primary:#27AE60;
}
`;

export const CardinhoNovo = styled.li`
  width: 365px;
  height: 160px;
  list-style: none;
  background-color: #f5f5f5;
  display: flex;
  gap: 3px;
  margin-bottom: 5px;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  overflow: hidden;

  span {
    width: 160px;
    height: 160px;
    border-radius: 4px;
    overflow: hidden;
  }

  section {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 110px;
    height: 120px;
    overflow: hidden;
  }

  button {
    color: white;
    background-color: #27ae60;
    border: none;
    padding: 8px;
    border-radius: 4px;
    margin-left: 5px;
  }
`;
export const DivCards = styled.div`
  width: 860px;
  /* margin-left: 4rem;
  margin-right: 1rem; */
  max-width: 100%;
  flex-wrap: wrap;
  display: flex;

  flex-direction: row;
  gap: 1rem;

  @media (max-width: 767px) {
    width: 100vw;
    max-width: 100%;
    overflow-x: scroll;
    flex-wrap: nowrap;
    /* padding: 0px 200px 00px 200px; */
  }
`;
export const Cards = styled.div`
  width: 300px;
  max-width: 250px;
  height: 355px;
  border-radius: 4px;
  align-items: left;
  border: 2px solid #f5f5f5;
  padding: 5px;

  button {
    color: white;
    background-color: #27ae60;
    border: none;
    padding: 8px;
    border-radius: 4px;
  }

  header {
    overflow: hidden;
    background-color: #f5f5f5;
    height: 150px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  img {
    height: 100%;
    align-self: center;
  }
`;

export const Cart = styled.section`
  width: 365px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px 6px 0px 0px;
  flex-direction: column;

  header {
    background-color: #27ae60;
    color: white;
    width: 365px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px 6px 0px 0px;
  }

  div {
    width: 365px;
    height: 165px;
    background-color: #f5f5f5;
  }
`;

export const Header = styled.header`
  /* width: 100vw; */
  height: 80px;
  padding-left: 8vw;
  padding-right: 8vw;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  div {
    position: relative;
    display: flex;
    width: 20%;
  }

  input {
    height: 55px;
    /* width: 250px; */
    width: 100%;
    border: solid #e0e0e0 2px;
    border-radius: 8px;
    margin-right: 8px;
  }

  button {
    position: absolute;
    right: 10px;
    top: 5px;
    height: 50px;
    width: 30%;
    border: solid #27ae60 2px;
    border-radius: 8px;
    background-color: #27ae60;
    color: white;

    @media (max-width: 767px) {
      display: none;
    }
  }

  @media (max-width: 767px) {
    padding: 0px;
  }
`;
export const Footer = styled.footer`
  background-color: #f5f5f5;
  width: 365px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0px 0 px 6px 6px;

  h4 {
    margin-left: 8px;
  }
  span {
    margin-right: 8px;
  }
`;
